import axios from "axios";
import type { Config, Contract, User } from "./models";
import { config as configStore, user as userStore, contract as contractStore } from "../stores";

async function loadConfig({language, basepath, apiurl, user, contract, repositories, isStandalone}) {
  if (isStandalone) return loadExternalConfig({language, basepath, apiurl, user, contract, repositories, isStandalone});

  let config: Config = {} as Config
  config.language = language
  config.apiUrl = apiurl + "/cut-manager/api/v1"
  config.basePath = basepath
  config.user = user
  config.contract = contract
  configStore.set(config)
  userStore.set(user)
  contractStore.set(contract)
}

async function loadExternalConfig({language, basepath, apiurl, user, contract, repositories, isStandalone}) {
  let index = window.location.pathname.indexOf("/cut-manager")
  if(index != -1) {
    basepath = window.location.pathname.substring(0, index) + "/cut-manager"
  }

  let resp = await axios.request<Config>({method: "GET", url: basepath  + "/config.json"})
  let config: Config = {} as Config

  config.isStandalone = resp?.data?.isStandalone || isStandalone || false
  if(resp?.data?.apiUrl) {
    if (resp?.data?.apiUrl.startsWith("http") || resp?.data?.apiUrl.startsWith("/")) {
      config.apiUrl = resp?.data?.apiUrl
    } else {
      config.apiUrl = basepath + "/" + resp?.data?.apiUrl
    }
  } else {
    config.apiUrl = apiurl || "/cut-manager/api/v1"
  }

  config.language = resp?.data?.language || language || "en"
  config.basePath = resp?.data?.basePath || basepath
  config.user = resp?.data?.user || user || {} as User
  config.contract = resp?.data?.contract || contract || {} as Contract
  configStore.set(config)
  userStore.set(config.user)
  contractStore.set(config.contract)
}

export default loadConfig;
